import React from 'react';
import PropTypes from 'prop-types';
import styles from './ImageContentSection.css';

function ImageContentSection({ imageSrc, imageMobileSrc, imageAlt, children }) {
    return (
        <section className={styles.root}>
            <div className={styles.container}>
                <picture>
                    <source
                        srcSet={imageMobileSrc}
                        media='(max-width: 518px)'
                    />
                    <img
                        src={imageSrc}
                        alt={imageAlt}
                        className={styles.image}
                    />
                </picture>
                <div className={styles.content}>
                    {children}
                </div>
            </div>
        </section>
    );
}

ImageContentSection.propTypes = {
    imageSrc: PropTypes.string.isRequired,
    imageMobileSrc: PropTypes.string.isRequired,
    imageAlt: PropTypes.string.isRequired,
    children: PropTypes.node.isRequired
};

export {
    ImageContentSection
};
